import { transform } from 'lodash';
import moment from "moment";
import vitiligoBasicInfoDialog from '../components/vitiligoBasicInfoDialog.vue';
import gql from 'graphql-tag';

export default {
  data() {
    return {
      isShowVitiligo: false,
      toDialoPatientsData: {},
      openVitiligoId: null,
      lastDiagnosisText: {
        bool: false,
        id: 0,
      },
      numberFields: ['height', 'weight', 'onset_age', 'duration_months', 'bsa_score'], // 数字类型字段
      dateFields: ['visit_date','update_time'], // 日期类型字段
    }
  },
  components: {
    vitiligoBasicInfoDialog
  },
  methods: {
    // 请求最近一次诊断的诊断结果
    getLastDiagnosisText(patientId) {
      this.lastDiagnosisText = {
        bool: !this.lastDiagnosisText.bool,
        id: patientId,
      };
    },
    async newVitiligo(event, item) {
      event.cancelBubble = true;
      // 请求一下住院号
      // item.medical_record_num = await this.getMedicalRecordNum(item.id);
      this.toDialoPatientsData = item;
      this.isShowVitiligo = true;
      console.log("newVitiligo,this.isShowVitiligo:", this.isShowVitiligo);
      this.getLastDiagnosisText(item.id);
    },
    setVitiligoStatus(data) {
      // this.$emit('setVitiligoStatus',val)
      this.isShowVitiligo = data;
      if (!data) {
        this.openVitiligoId = null;
      }
    },
    getVitiligo(elId, item) {
      // console.log(elId,item)
      this.openVitiligoId = elId;
      this.isShowVitiligo = true;
      this.toDialoPatientsData = item
    },
    async refreshHandler(data) {
      await this.changeHandler(data);
      // console.log(data)
    },
    // 获取住院号
    async getMedicalRecordNum(patientId) {
      try {
        const res = await this.$apollo.query({
          query: gql`{
            patient(id: ${patientId}){
              id
              medical_record_num
            }
          }`,
          fetchPolicy: "no-cache",
        });
        return res.data.patient.medical_record_num;
      } catch (error) {
        this.$message.error('住院号获取失败');
        return '';
      }
    },

    transformVitiligoData(data) {
      const newData = {};
      for(let key in data){
          // console.log(key, this.numberFields.includes(key));
          if(this.numberFields.includes(key)){
            if(data[key]===-1 || data[key]===null){
              newData[key] = '';
            }else{
              newData[key] = Number(data[key]);
            }            
          }else if(this.dateFields.includes(key)){
            if(data[key]!== -30610253143000){
              newData[key] = moment(data[key]).format("YYYY-MM-DD");
            }else{
              newData[key] = "";
            }
          } else{
            newData[key] = data[key];
          }           
      }
      return newData;
    }
  }
}
